var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientsPageLandingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.59 29.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #3b4559;\n        stroke-width: .15px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #3b4559;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #ffe600;\n        stroke: #ffe600;\n        stroke-width: .22px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.3,
    y: 0,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.95,
    y: 0,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 7.65,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.65,
    y: 7.65,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.3,
    y: 7.65,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.95,
    y: 7.65,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 15.3,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.65,
    y: 15.3,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.3,
    y: 15.3,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 22.95,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.65,
    y: 22.95,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.3,
    y: 22.95,
    width: 6.12,
    height: 6.12,
    rx: 3.06,
    ry: 3.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.73,25.44v.51h-4.13v-7.17h4.08v.51h-3.53v2.79h3.28v.51h-3.28v2.85h3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.26,20.83l-2.16,5.12h-.62l-2.17-5.12h.55l1.92,4.59,1.94-4.59h.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.03,19.18c0-.21,.18-.4,.41-.4s.41,.18,.41,.4-.18,.41-.41,.41-.41-.18-.41-.41Zm.15,1.65h.51v5.12h-.51v-5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.3,18.78v7.17h-.51v-1.19c-.42,.79-1.21,1.3-2.2,1.3-1.46,0-2.65-1.16-2.65-2.67s1.19-2.67,2.65-2.67c.99,0,1.78,.51,2.2,1.3v-3.24h.51Zm-.51,4.61c0-1.22-.95-2.18-2.17-2.18s-2.17,.96-2.17,2.18,.95,2.18,2.17,2.18,2.17-.96,2.17-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.71,23.41c0,.08-.01,.16-.01,.25h-4.64c.12,1.16,1,1.91,2.17,1.91,.84,0,1.47-.39,1.77-.93l.45,.27c-.42,.7-1.22,1.16-2.23,1.16-1.58,0-2.69-1.13-2.69-2.67s1.08-2.67,2.65-2.67,2.53,1.29,2.53,2.69Zm-4.65-.26h4.12c-.11-1.25-.99-1.95-2-1.95-1.17,0-2.02,.81-2.12,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.24,22.77v3.18h-.52v-3.18c0-.94-.54-1.56-1.5-1.56s-1.79,.66-1.79,2.04v2.7h-.51v-5.12h.51v.97c.39-.76,1.04-1.09,1.83-1.09,1.22,0,1.99,.81,1.99,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.34,23.39c0-1.52,1.15-2.67,2.69-2.67,1,0,1.86,.51,2.23,1.31l-.42,.25c-.3-.64-.99-1.06-1.81-1.06-1.24,0-2.17,.96-2.17,2.18s.93,2.18,2.17,2.18c.83,0,1.51-.43,1.84-1.06l.43,.26c-.41,.79-1.27,1.3-2.27,1.3-1.55,0-2.69-1.16-2.69-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.21,23.41c0,.08-.01,.16-.01,.25h-4.64c.12,1.16,1,1.91,2.17,1.91,.84,0,1.47-.39,1.77-.93l.45,.27c-.42,.7-1.22,1.16-2.23,1.16-1.58,0-2.69-1.13-2.69-2.67s1.08-2.67,2.65-2.67,2.53,1.29,2.53,2.69Zm-4.65-.26h4.12c-.11-1.25-.99-1.95-2-1.95-1.17,0-2.02,.81-2.12,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.99,25.95h-.54v-6.37l-2.65,4.4h-.09l-2.65-4.4v6.37h-.54v-7.17h.68l2.56,4.24,2.56-4.24h.69v7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.69,20.83v5.12h-.52v-1.16c-.43,.77-1.22,1.27-2.2,1.27-1.45,0-2.65-1.16-2.65-2.67s1.2-2.67,2.65-2.67c.98,0,1.77,.5,2.2,1.27v-1.16h.52Zm-.52,2.56c0-1.22-.94-2.18-2.16-2.18s-2.17,.96-2.17,2.18,.95,2.18,2.17,2.18,2.16-.96,2.16-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.64,23.39c0,1.52-1.19,2.67-2.65,2.67-.99,0-1.78-.51-2.2-1.3v3.24h-.51v-7.17h.51v1.19c.42-.79,1.21-1.3,2.2-1.3,1.46,0,2.65,1.16,2.65,2.67Zm-.51,0c0-1.22-.95-2.18-2.17-2.18s-2.17,.96-2.17,2.18,.95,2.18,2.17,2.18,2.17-.96,2.17-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.31,25.59c0-.26,.19-.46,.46-.46s.46,.21,.46,.46-.2,.46-.46,.46-.46-.21-.46-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.89,23.39c0-1.52,1.15-2.67,2.69-2.67,1,0,1.86,.51,2.23,1.31l-.42,.25c-.3-.64-.99-1.06-1.81-1.06-1.24,0-2.17,.96-2.17,2.18s.93,2.18,2.17,2.18c.83,0,1.51-.43,1.84-1.06l.43,.26c-.41,.79-1.27,1.3-2.27,1.3-1.55,0-2.69-1.16-2.69-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.58,23.39c0-1.52,1.2-2.67,2.69-2.67s2.68,1.16,2.68,2.67-1.2,2.67-2.68,2.67-2.69-1.16-2.69-2.67Zm4.85,0c0-1.22-.94-2.18-2.16-2.18s-2.17,.96-2.17,2.18,.95,2.18,2.17,2.18,2.16-.96,2.16-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.51,22.7v3.25h-.51v-3.25c0-.97-.56-1.49-1.36-1.49-.86,0-1.54,.57-1.54,1.88v2.86h-.51v-3.25c0-.97-.52-1.49-1.31-1.49-.84,0-1.59,.57-1.59,1.88v2.86h-.51v-5.12h.51v.88c.38-.71,.99-.99,1.65-.99,.75,0,1.33,.37,1.6,1.04,.37-.72,1.02-1.04,1.71-1.04,1.09,0,1.86,.71,1.86,1.99Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsPageLandingLogo);
export default __webpack_public_path__ + "static/media/clients_page_landing_logo.ab245c1354f54f55745c7a279eddb4a8.svg";
export { ForwardRef as ReactComponent };